<template>
  <el-dialog
    append-to-body
    :title="'Редактирование значения ' + _value.label"
    :visible.sync="_dialogVisible"
    width="30%"
  >
    <el-form-item :label="`Название`">
      <el-input v-model="_value.label" @input="() => _value.value = _value.label"/>
    </el-form-item>


    <template v-if="!type.includes('nomenclature') || form.notActive[1]">
      <el-form-item :label="`Значение поля 1`"
                    v-if="!type.includes('materials') && !type.includes('constructions') && !(type.includes('nomenclature') && form.notActive[1])">
        <el-input v-model="_value.details[1]" v-if="_value.details"/>
      </el-form-item>
      <div v-else>
        <unit-select
          v-model="_value.details[1]" v-if="_value.details"
          label="Ед. изм."
        />
      </div>

      <template v-if="!type.includes('nomenclature')">

        <el-form-item :label="`Значение поля 2`" v-if="!type.includes('materials')">
          <el-input v-model="_value.details[2]" v-if="_value.details"/>
        </el-form-item>
        <el-form-item :label="`План`" v-else>
          <el-input type="number" v-model="_value.details[2]" v-if="_value.details"/>
        </el-form-item>
      </template>
      <template  v-else-if="!type.includes('nomenclature') || !form.withoutPlan">
        <el-form-item :label="`План`">
          <el-input type="number" v-model="_value.details[2]" v-if="_value.details"/>
        </el-form-item>
      </template>
    </template>

    <template v-if="!type.includes('nomenclature') || form.notActive[2]">
      <el-form-item :label="`Значение поля 3`"
                    v-if="!type.includes('constructions') && !(type.includes('nomenclature') && form.notActive[2])">
        <el-input v-model="_value.details[3]" v-if="_value.details"/>
      </el-form-item>
      <div v-else>
        <unit-select
          v-model="_value.details[3]" v-if="_value.details"
          label="Ед. изм. 2"
        />
      </div>

      <el-form-item :label="`Значение поля 4`" v-if="!type.includes('constructions') && !type.includes('nomenclature')">
        <el-input v-model="_value.details[4]" v-if="_value.details"/>
      </el-form-item>

      <el-form-item :label="`План на ед.`" v-else-if="!type.includes('nomenclature') || !form.withoutPlan">
        <el-input type="number" v-model="_value.details[4]" v-if="_value.details"/>
      </el-form-item>
    </template>


    <el-form-item :label="`Значение поля 5`">
      <el-input v-model="_value.details[5]" v-if="_value.details"/>
    </el-form-item>

    <template v-if="type.includes('nomenclature')">


      <el-form-item :label="`Значение поля 6`">
        <el-input v-model="_value.details[6]" v-if="_value.details"/>
      </el-form-item>


      <el-form-item :label="`Значение поля 7`">
        <el-input v-model="_value.details[7]" v-if="_value.details"/>
      </el-form-item>


      <el-form-item :label="`Значение поля 8`">
        <el-input v-model="_value.details[8]" v-if="_value.details"/>
      </el-form-item>


      <el-form-item :label="`Значение поля 9`">
        <el-input v-model="_value.details[9]" v-if="_value.details"/>
      </el-form-item>

      <el-form-item :label="`Значение поля 10`">
        <el-input v-model="_value.details[10]" v-if="_value.details"/>
      </el-form-item>

    </template>


    <span slot="footer" class="dialog-footer">
      <el-button type="danger" @click="remove(_value)">Удалить</el-button>
      <el-button @click="$emit('close')">Сохранить и закрыть</el-button>
    </span>
  </el-dialog>

</template>

<script>
import UnitSelect from "../components/unitSelect";
import firebase from 'firebase';

export default {
  name: "AddOption",
  components: {UnitSelect},
  props: {
    form: Object,
    value: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean
    }
  },
  methods: {
    async remove(openEdit) {
      // try {
        if (openEdit.isCreate) {
          await myFirestore
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('inputs')
            .doc(this.$route.params.id)
            .collection('optionsList').doc(openEdit.uid).delete()
        }
      this._value.isDelete = true
      // } catch (e) {
      //   console.log(e)
      // }
      this.$emit('remove', openEdit)
    }
  },
  computed: {
    _dialogVisible: {
      get() {
        return this.dialogVisible
      },
      set(v) {
        if (!v) {
          this.$emit('close', v)
        }
      }
    },
    _value: {
      get() {
        return this.value || {}
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Inputs/AddOption.vue